import { useState, createContext, useContext, useEffect } from "react";
import apisService from "api/services/apiService";
import { useCustomQuery } from "hooks";
import { getLocalStorage } from "utils/localStorageUtils";

const ProjectContext = createContext();

export const ProjectContextProvider = ({ children }) => {
  const projectId = getLocalStorage("projectId");

  const [donutValues, setDonutValues] = useState([]);
  const [totalParcelsCount, setTotalParcelsCount] = useState({});

  // ✅ Project Details Query
  const { data: projectData, isPending: projectDataLoading } = useCustomQuery({
    keys: ["project", String(projectId)],
    fetchFn: (_, cancelToken) =>
      apisService.project.getProjectDataAPI(projectId, cancelToken),
    options: { enabled: !!projectId },
  });

  // ✅ Project Settings Query
  const { data: projectSettings } = useCustomQuery({
    keys: ["project-settings", String(projectId)],
    fetchFn: (_, cancelToken) =>
      apisService.project.getProjectSettingsAPI(projectId, cancelToken),
    options: { enabled: !!projectId },
  });

  // ✅ Project Statistics Query
  const { data: projectStatistics } = useCustomQuery({
    keys: ["project-statistics", String(projectId)],
    fetchFn: (_, cancelToken) =>
      apisService.project.getProjectStatisticsAPI(projectId, cancelToken),
    options: { enabled: !!projectId },
  });

  useEffect(() => {
    if (projectStatistics) {
      const {
        parcelsCount,
        statistics,
        onlineParcelsCount,
        offlineParcelsCount,
      } = projectStatistics;
      setTotalParcelsCount({
        parcelsCount,
        onlineParcelsCount,
        offlineParcelsCount,
      });
      setDonutValues(statistics);
    }
  }, [projectStatistics]);

  return (
    <ProjectContext.Provider
      value={{
        projectSettings,
        projectData,
        donutValues,
        setDonutValues,
        totalParcelsCount,
        setTotalParcelsCount,
        projectDataLoading,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};

export const useProjectContext = () => {
  return useContext(ProjectContext);
};
